export default {
  currentSubscription: null,
  priceBreakdown: null,
  clientSecret: null,
  paymentStatus: null,
};
